window.Sparkle = window.Sparkle || {};

(function () {
  window.Sparkle.prepareSendTextForm = async function (modalSelector) {
    const composer = window.Sparkle.messageComposer;
    const root = composer.rootElement(modalSelector);
    if (!root) {
      return;
    }

    await composer.hydrate(root, "protected-message");

    const picker = await composer.hydrate(root, "message-template");
    composer.onTemplatePick(picker, (template) => applyTemplate(root, template));
  };

  function applyTemplate(root, template) {
    const body = root.querySelector("#patient_text_message_text_body_contenteditable");

    body.innerHTML = template.dataset.body ?? "";
    // The hidden field this contenteditable feeds is synced by a delegated focusout handler, which a
    // scripted edit never fires, so the submitted value is written here.
    window.Sparkle.messageComposer.syncContenteditableTarget(body);
  }
})();
